(function () {
  var C = window.DSD || {};
  var dr = document.getElementById('dsd-drawer');
  var ST = (dr && dr.getAttribute('data-style')) || 'a';
  var fmt = function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
  var escA = function (s) { return esc(s).replace(/"/g, '&quot;'); };
  function json(url, opt) {
    opt = opt || {}; opt.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json' }, opt.headers || {});
    return fetch(url, opt).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function setCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = n; }); }
  function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }
  var sv = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  var IC = { check: sv('M5 12.5l4.5 4.5L19 7.5'), trash: sv('M4 7h16M9 7V4h6v3M6.5 7l1 13h9l1-13M10 11v6M14 11v6'), left: sv('M15 6l-6 6 6 6'), right: sv('M9 6l6 6-6 6'), copy: sv('M9 9h11v11H9zM5 15V4h11') };
  var recCache = {}, lastCart = null;

  function itemSave(it) {
    var c = C.cmp && C.cmp[it.variant_id], base = Math.max(c && c > it.price ? c * it.quantity : 0, it.original_line_price || 0);
    return base > it.final_line_price ? base - it.final_line_price : 0;
  }
  function ship(cart, el) {
    var t = (Number(C.free) || 0) * 100, left = t - cart.total_price, out = '', done = true;
    if (t && left > 0) {
      done = false;
      out = '<span>Nog <b>' + fmt(left) + '</b> tot gratis verzending</span><i><s style="width:' + Math.round(cart.total_price / t * 100) + '%"></s></i>';
    } else if (C.banner) {
      out = '<span>' + IC.check + esc(C.banner) + '</span>' + (ST === 'a' ? '' : '<i><s style="width:100%"></s></i>');
    }
    if (ST === 'c' && C.countdown) out += '<span class="dsd-dk__cd" data-dsd-countdown></span>';
    el.innerHTML = out; el.hidden = !out; el.classList.toggle('is-done', done);
  }
  function item(it) {
    var name = (C.names && C.names[it.handle]) || it.product_title;
    var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="dsd-dk__var">' + esc(it.variant_title) + '</span>' : '';
    var s = C.save ? itemSave(it) : 0;
    return '<div class="dsd-dk__item"><a class="dsd-dk__img" href="' + it.url + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + img(it.image, 200) + '" alt="">' : '') + '</a>' +
      '<div class="dsd-dk__info"><div class="dsd-dk__row"><a class="dsd-dk__name" href="' + it.url + '">' + esc(name) + '</a>' +
      '<button type="button" class="dsd-dk__del" data-line="' + it.key + '" data-qty="0" aria-label="Verwijder ' + escA(name) + '">' + IC.trash + '</button></div>' + vt +
      '<div class="dsd-dk__row"><div class="dsd-qty"><button type="button" aria-label="Minder" data-line="' + it.key + '" data-qty="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Meer" data-line="' + it.key + '" data-qty="' + (it.quantity + 1) + '">+</button></div>' +
      '<span class="dsd-dk__price">' + (s ? '<s>' + fmt(it.final_line_price + s) + '</s>' : '') + '<b>' + fmt(it.final_line_price) + '</b></span></div>' +
      (s ? '<span class="dsd-dk__save">' + IC.check + 'Je bespaart ' + fmt(s) + '</span>' : '') + '</div></div>';
  }
  function fetchRecs(pid) {
    if (!C.recUrl) { recCache[pid] = []; return; }
    fetch(C.recUrl + '.json?product_id=' + pid + '&limit=6&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        recCache[pid] = (d.products || []).map(function (p) {
          var v = (p.variants || [])[0] || {};
          return { id: v.id, pid: p.id, t: (C.names && C.names[p.handle]) || p.title, p: p.price, c: p.compare_at_price || 0, img: p.featured_image || '', url: p.url, ok: p.available && v.available !== false };
        });
        if (lastCart && dr && dr.classList.contains('is-open')) render(lastCart);
      })
      .catch(function () { recCache[pid] = []; });
  }
  function recList(cart, skip) {
    var list = (C.recs || []).slice();
    if (C.recsAuto && cart.items.length) {
      var pid = cart.items[0].product_id;
      if (!(pid in recCache)) { recCache[pid] = null; fetchRecs(pid); }
      else if (recCache[pid]) list = list.concat(recCache[pid]);
    }
    var ex = cart.items.map(function (i) { return i.product_id; }).concat(skip || []), seen = {}, out = [];
    list.forEach(function (r) { if (!r || !r.ok || !r.id || seen[r.pid] || ex.indexOf(r.pid) > -1) return; seen[r.pid] = 1; out.push(r); });
    return out.slice(0, 8);
  }
  function rec(r) {
    return '<div class="dsd-dk__rec"><a class="dsd-dk__rimg" href="' + r.url + '" tabindex="-1" aria-hidden="true">' + (r.img ? '<img src="' + img(r.img, 240) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="dsd-dk__rinfo"><a class="dsd-dk__rname" href="' + r.url + '">' + esc(r.t) + '</a><span class="dsd-dk__rprice">' + (r.c > r.p ? '<s>' + fmt(r.c) + '</s>' : '') + fmt(r.p) + '</span></div>' +
      '<button type="button" class="dsd-dk__add" data-dsd-add="' + r.id + '" aria-label="' + escA(r.t) + ' toevoegen">' + (ST === 'b' ? '+ ' : '') + 'Toevoegen</button></div>';
  }
  function social() {
    var h = '';
    if (C.proof) {
      var inner = '<span class="dsd-dk__stars" aria-hidden="true">★★★★★</span><span>' + esc(C.proof) + '</span>';
      h += C.trustpilot ? '<a class="dsd-dk__proof" href="' + escA(C.trustpilot) + '" target="_blank" rel="noopener">' + inner + '</a>' : '<div class="dsd-dk__proof">' + inner + '</div>';
    }
    if (C.quote) h += '<blockquote class="dsd-dk__quote"><p>“' + esc(C.quote) + '”</p>' + (C.quoteName ? '<cite>' + esc(C.quoteName) + '</cite>' : '') + '</blockquote>';
    return h ? '<div class="dsd-dk__social">' + h + '</div>' : '';
  }
  function empty() {
    var ps = (C.empties || []).filter(function (p) { return p && p.id; });
    var h = '<div class="dsd-dk__empty"><p class="dsd-dk__etitle">' + esc(C.emptyText) + '</p>';
    if (ps.length) {
      if (C.emptySub) h += '<p class="dsd-dk__esub">' + esc(C.emptySub) + '</p>';
      h += '<div class="dsd-dk__egrid">' + ps.map(function (p) {
        return '<div class="dsd-dk__ecard"><a class="dsd-dk__eimg" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + img(p.img, 300) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="dsd-dk__einfo"><a class="dsd-dk__ename" href="' + p.url + '">' + esc(p.t) + '</a><span class="dsd-dk__eprice">' + (p.c > p.p ? '<s>' + fmt(p.c) + '</s>' : '') + fmt(p.p) + '</span></div>' +
          (p.ok ? '<button type="button" class="dsd-dk__eadd" data-dsd-add="' + p.id + '" aria-label="' + escA(p.t) + ' toevoegen">+ Toevoegen</button>' : '<span class="dsd-dk__eadd is-out">Uitverkocht</span>') + '</div>';
      }).join('') + '</div>';
    }
    if (C.emptyCode) {
      h += '<div class="dsd-dk__code"><div>' + (C.emptyCodeText ? '<span class="dsd-dk__ctext">' + esc(C.emptyCodeText) + '</span>' : '') + '<span class="dsd-dk__cval">' + esc(C.emptyCode) + '</span></div>' +
        '<button type="button" class="dsd-dk__copy" data-dsd-copy="' + escA(C.emptyCode) + '">' + IC.copy + '<span aria-live="polite">Kopieer</span></button></div>';
      if (C.emptyCodeNote) h += '<p class="dsd-dk__cnote">' + esc(C.emptyCodeNote) + '</p>';
    }
    return h + '<a class="dsd-btn dsd-btn--dark dsd-btn--full dsd-dk__ebtn" href="' + C.emptyUrl + '">' + esc(C.emptyButton) + '</a></div>';
  }
  function fallbackCopy(t) {
    var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.position = 'fixed'; a.style.opacity = '0';
    (dr || document.body).appendChild(a); a.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (x) {} a.remove(); return ok;
  }
  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t).catch(function () { return fallbackCopy(t); });
    return Promise.resolve(fallbackCopy(t));
  }
  function render(cart) {
    lastCart = cart;
    setCount(cart.item_count);
    if (!dr) return;
    var body = dr.querySelector('[data-body]'), foot = dr.querySelector('[data-foot]'), sh = dr.querySelector('[data-ship]'), hc = dr.querySelector('[data-head-count]');
    if (hc) hc.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.item_count) {
      body.innerHTML = empty();
      foot.hidden = true; if (sh) sh.hidden = true; return;
    }
    if (sh) ship(cart, sh);
    var saved = 0, items = '';
    cart.items.forEach(function (it) { items += item(it); if (C.save) saved += itemSave(it); });
    var cdt = 0, cdn = [];
    (cart.cart_level_discount_applications || []).forEach(function (a) { cdt += a.total_allocated_amount || 0; if (a.title) cdn.push(a.title); });
    var html = '<div class="dsd-dk__items">' + items + '</div>';
    if (ST === 'c' && (saved || cdt)) html += '<div class="dsd-dk__savebox">' + IC.check + '<span>Je bespaart <b>' + fmt(saved + cdt) + '</b> op deze bestelling</span></div>';
    var u = C.upsell, skip = [];
    if (u && u.ok) {
      var has = cart.items.some(function (i) { return i.product_id === u.pid; });
      var trig = !C.upsellWhen || !C.upsellWhen.length || cart.items.some(function (i) { return C.upsellWhen.indexOf(i.product_id) > -1; });
      if (!has && trig) {
        skip.push(u.pid);
        html += '<div class="dsd-dk__up">' + (u.img ? '<img src="' + u.img + '" alt="">' : '') +
          '<div style="flex:1;min-width:0"><strong style="font-size:15px">' + esc(C.upsellTitle) + '</strong><br><span class="dsd-muted">' + esc(C.upsellText) + '</span></div>' +
          '<button type="button" class="dsd-btn dsd-btn--red" data-dsd-add="' + u.id + '">+ ' + fmt(u.price) + '</button></div>';
      }
    }
    var list = recList(cart, skip);
    if (list.length) {
      html += '<section class="dsd-dk__recs" aria-label="' + escA(C.recsTitle) + '"><div class="dsd-dk__rh"><h3 class="dsd-dk__h">' + esc(C.recsTitle) + '</h3>' +
        (ST === 'a' && list.length > 1 ? '<div class="dsd-dk__arr"><button type="button" data-rscroll="-1" aria-label="Vorige">' + IC.left + '</button><button type="button" data-rscroll="1" aria-label="Volgende">' + IC.right + '</button></div>' : '') +
        '</div><div class="dsd-dk__track">' + list.map(rec).join('') + '</div></section>';
    }
    html += social();
    body.innerHTML = html;
    foot.hidden = false;
    foot.querySelector('[data-sub]').textContent = fmt(cart.total_price);
    var ct = foot.querySelector('[data-count-txt]'); if (ct) ct.textContent = cart.item_count + (cart.item_count === 1 ? ' product' : ' producten');
    var bp = foot.querySelector('[data-btn-price]'); if (bp) bp.textContent = '· ' + fmt(cart.total_price);
    var sd = foot.querySelector('[data-saved]');
    if (sd) {
      var parts = [];
      if (cdt) parts.push('Korting ' + cdn.join(', ') + ': −' + fmt(cdt));
      if (saved && ST !== 'c') parts.push('Je bespaart ' + fmt(saved));
      sd.hidden = !parts.length; sd.textContent = parts.join(' · ');
    }
    if (window.dsdCountdown) window.dsdCountdown();
  }
  function load() { return json(C.cartUrl + '.js').then(render); }
  function open() {
    if (!dr) { window.location.href = C.cartUrl; return; }
    dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    load(); setTimeout(function () { var b = dr.querySelector('[data-close-btn]'); if (b) b.focus(); }, 60);
  }
  function close() {
    if (!dr) return; dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  window.dsdOpenCart = open;
  window.dsdAdd = function (items, btn) {
    if (btn) btn.disabled = true;
    return json(C.addUrl + '.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function () { if (btn) btn.disabled = false; if (C.drawer && dr) open(); else window.location.href = C.cartUrl; })
      .catch(function () { if (btn) btn.disabled = false; alert('Toevoegen lukte niet. Probeer het opnieuw of neem contact op.'); });
  };
  document.addEventListener('click', function (e) {
    var cp = e.target.closest('[data-dsd-copy]');
    if (cp) {
      var lab = cp.querySelector('span');
      copyText(cp.getAttribute('data-dsd-copy')).then(function () {
        cp.classList.add('is-copied'); if (lab) lab.textContent = 'Gekopieerd';
        clearTimeout(cp._t); cp._t = setTimeout(function () { cp.classList.remove('is-copied'); if (lab) lab.textContent = 'Kopieer'; }, 2500);
      });
      return;
    }
    var a = e.target.closest('[data-dsd-add]');
    if (a) { e.preventDefault(); var ids = a.getAttribute('data-dsd-add').split(',').filter(Boolean); window.dsdAdd(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), a); return; }
    var sc = e.target.closest('[data-rscroll]');
    if (sc) { var tr = sc.closest('.dsd-dk__recs').querySelector('.dsd-dk__track'); tr.scrollBy({ left: Number(sc.getAttribute('data-rscroll')) * tr.clientWidth * 0.86, behavior: 'smooth' }); return; }
    if (e.target.closest('[data-open-cart]') && C.drawer && dr && !C.onCartPage) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-close]')) { close(); return; }
    var q = e.target.closest('[data-line]');
    if (q && dr) {
      dr.classList.add('is-busy');
      json(C.changeUrl + '.js', { method: 'POST', body: JSON.stringify({ id: q.getAttribute('data-line'), quantity: Math.max(0, Number(q.getAttribute('data-qty'))) }) })
        .then(render).finally(function () { dr.classList.remove('is-busy'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dr && dr.classList.contains('is-open')) close(); });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!C.drawer || !dr || e.defaultPrevented || !f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    fetch(C.addUrl + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; open(); })
      .catch(function () { alert('Toevoegen lukte niet. Mogelijk is dit product uitverkocht.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();